import React from 'react';
import { LayoutDashboardIcon, FolderPlusIcon, FileCheckIcon, AlertTriangleIcon, GitBranchIcon, FileOutputIcon, CalendarIcon, HistoryIcon, UsersIcon } from 'lucide-react';
type NavigationItem = {
  id: string;
  label: string;
  icon: string;
};
type SidebarProps = {
  navigationItems: NavigationItem[];
  activeTab: string;
  setActiveTab: (id: string) => void;
};
export function Sidebar({
  navigationItems,
  activeTab,
  setActiveTab
}: SidebarProps) {
  const getIcon = (iconName: string) => {
    switch (iconName) {
      case 'LayoutDashboard':
        return <LayoutDashboardIcon className="w-5 h-5" data-id="element-1656" />;
      case 'FolderPlus':
        return <FolderPlusIcon className="w-5 h-5" data-id="element-1657" />;
      case 'FileCheck':
        return <FileCheckIcon className="w-5 h-5" data-id="element-1658" />;
      case 'AlertTriangle':
        return <AlertTriangleIcon className="w-5 h-5" data-id="element-1659" />;
      case 'GitBranch':
        return <GitBranchIcon className="w-5 h-5" data-id="element-1660" />;
      case 'FileOutput':
        return <FileOutputIcon className="w-5 h-5" data-id="element-1661" />;
      case 'Calendar':
        return <CalendarIcon className="w-5 h-5" data-id="element-1662" />;
      case 'History':
        return <HistoryIcon className="w-5 h-5" data-id="element-1663" />;
      case 'Users':
        return <UsersIcon className="w-5 h-5" data-id="element-1664" />;
      default:
        return <LayoutDashboardIcon className="w-5 h-5" data-id="element-1665" />;
    }
  };
  return <div className="w-64 bg-background border-r border-border flex flex-col h-full overflow-auto" data-id="element-1666">
      <nav className="flex-1 pt-4 px-4" data-id="element-1667">
        <div className="mb-6" data-id="element-1668">
          <p className="mb-2 text-sm text-muted-foreground" data-id="element-1669">Capital Markets</p>
          <ul className="space-y-1" data-id="element-1670">
            {navigationItems.map(item => <li key={item.id} data-id="element-1671">
                <button onClick={() => setActiveTab(item.id)} className={`w-full flex items-center px-3 py-2 text-sm rounded-md text-left transition-colors ${activeTab === item.id ? 'text-success font-medium' : 'text-foreground/60 hover:bg-muted hover:text-foreground'}`} data-id="element-1672">
                  <span className="mr-3 text-current" data-id="element-1673">
                    {getIcon(item.icon)}
                  </span>
                  <span data-id="element-1674">{item.label}</span>
                </button>
              </li>)}
          </ul>
        </div>
      </nav>
    </div>;
}